// ============================================================================
// marketConstants.ts — КОНСТАНТЫ витрины маркетплейса (лёгкий модуль).
// Отдельно от lib/market.ts, чтобы проверка наличия модуля в оболочке
// (useVisibleApps → marketPresence) не тянула layer данных/файлов/чата.
// ============================================================================

/** Код клиентского приложения в реестре рендереров (не серверный kind='app'). */
export const MARKET_CLIENT_APP_CODE = 'market_client';

export const MARKET_REQUEST_TABLE = 'mkt_requests';
export const MARKET_CATEGORY_TABLE = 'mkt_categories';
export const MARKET_SERVICE_TABLE = 'mkt_services';
export const MARKET_MASTER_TABLE = 'mkt_masters';
export const MARKET_STATUS_ENUM = 'MktRequestStatus';

/** Ограничения фото в клиентской витрине (UX-проверка; сервер не ограничивает). */
export const MARKET_MAX_PHOTOS = 6;
export const MARKET_MAX_PHOTO_BYTES = 15 * 1024 * 1024;

export const MARKET_WIZARD_STEPS = ['Категория', 'Адрес', 'Описание', 'Телефон'] as const;
